export const CONTINGENCY = 2 / 100; // 5%
export const CONTINGENCY_PERCENTAGE_TEXT = `${CONTINGENCY * 100}`;
